import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=71e7662c&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e7662c')) {
      api.createRecord('71e7662c', component.options)
    } else {
      api.reload('71e7662c', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=71e7662c&", function () {
      api.rerender('71e7662c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JQ25hwKUE9fQ/JS/ImageCarousel.vue"
export default component.exports